import {
  jb_article_row_css_default
} from "./chunk.AULW6IGV.js";
import {
  Linkable,
  Spaceable
} from "./chunk.UK6KU6OP.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-row/jb-article-row.ts
var JbArticleRow = class extends Linkable(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.direction = "horizontal";
    this._isDisabled = false;
  }
  _getContentSpacingProperties() {
    return { colsMdUp: "none" };
  }
  _loadMoreArticles(event) {
    event.detail.clickEvent.preventDefault();
    this._isDisabled = true;
    fetch(this.loadMoreUrl).then((response) => response.json()).then((data) => this._populateFetchedArticleData(data));
  }
  _populateFetchedArticleData(data) {
    [...data.items].forEach((item) => {
      const newItem = {
        teaserHeader: {
          headline: item.title
        },
        teaserMeta: {
          date: item.date,
          category: item.mainTag.title,
          link: {
            href: item.mainTag.url
          },
          time: item.readingTime
        },
        link: {
          href: item.url
        }
      };
      switch (item.type) {
        case "image":
          newItem.teaserHeader.picture = {
            alt: item.title,
            imgData: item.picture
          };
          break;
        case "video":
          newItem.teaserHeader.thumbnail = {
            backgroundPicture: {
              alt: item.title,
              imgData: item.picture
            },
            aspect: "aspect_3by2",
            type: "video"
          };
          break;
        case "audio":
          newItem.teaserHeader.thumbnail = {
            backgroundPicture: {
              alt: item.title,
              imgData: item.picture
            },
            aspect: "aspect_3by2",
            type: "audio"
          };
          break;
        case "video-preview":
          newItem.teaserHeader.thumbnail = {
            videoSrc: item.previewVideo,
            type: "video",
            aspect: "aspect_3by2"
          };
          break;
        default:
          break;
      }
      this.articleCards?.push(newItem);
    });
    this._isDisabled = false;
    this.loadMoreUrl = data.nextUrl;
  }
  _renderArticles() {
    return this.articleCards.map(
      (articleCard) => ke`
        <jb-article-card
          .direction="${this.direction === "vertical" ? "horizontal" : "vertical"}"
          .link=${articleCard.link}
          .teaserHeader=${articleCard.teaserHeader}
          .teaserMeta=${articleCard.teaserMeta}
        ></jb-article-card>
      `
    );
  }
  _renderButton() {
    if (this.loadMoreUrl && this.buttonText) {
      return ke`<jb-button-secondary
        @jb-button:clicked=${this._loadMoreArticles}
        .name=${"load-more"}
        .disabled=${this._isDisabled}
        >${this.buttonText}</jb-button-secondary
      >`;
    }
    if (this.link && this.buttonText) {
      return ke`<jb-button-secondary .link=${this.link}>${this.buttonText}</jb-button-secondary>`;
    }
    return "";
  }
  render() {
    const map = {
      cardcontainer: true,
      morecards: this.direction !== "vertical" && this.articleCards.length > 2,
      twocards: this.direction !== "vertical" && this.articleCards.length <= 2,
      vertical: this.direction === "vertical"
    };
    return ke`
      <aside>
        ${this.headline ? ke`<div class="title_wrap">
              <div class="title_content">
                ${this.headline ? ke`<jb-section-headline headline="${this.headline}"></jb-section-headline>` : D}
              </div>
            </div>` : D}

        <div class="${Rt(map)}">${this._renderArticles()}</div>
        ${this.buttonText && (this.loadMoreUrl || this.link) ? ke`<div class="button_container">${this._renderButton()}</div>` : D}
      </aside>
    `;
  }
};
JbArticleRow.styles = [reset_css_default, jb_article_row_css_default];
__decorateClass([
  n({ type: Array })
], JbArticleRow.prototype, "articleCards", 2);
__decorateClass([
  n()
], JbArticleRow.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbArticleRow.prototype, "direction", 2);
__decorateClass([
  n()
], JbArticleRow.prototype, "headline", 2);
__decorateClass([
  n()
], JbArticleRow.prototype, "loadMoreUrl", 2);
__decorateClass([
  r2()
], JbArticleRow.prototype, "_isDisabled", 2);
JbArticleRow = __decorateClass([
  customElement("jb-article-row")
], JbArticleRow);

export {
  JbArticleRow
};
